<template>
  <div class="product-item">
    <div>
      <SfHeading
        :level="4"
        :description="product.Product.Name"
        :title="product.Product.Sku"
        class="sf-heading--left m-b-10"
      />
      <div>
        <SfQuantitySelector
          class="f-right"
          v-model="qty"
          aria-label="Quantity"
          @input="productQty"
        />
        <template if="isProductAvailable">
          <SfProperty
            class="column-property old-price m-b-10"
            v-if="oldPrice"
            :name="$t('Gross Catalog Price')"
            :value="currencyFormatter().format(oldPrice)"
          />
          <SfProperty
            class="column-property old-price m-b-10"
            v-if="oldPriceNetto && showPriceNetto()"
            :name="$t('Net Catalog Price')"
            :value="currencyFormatter().format(oldPriceNetto)"
          />
          <SfProperty
            class="column-property price m-tb-10"
            v-if="price"
            :name="$t('Gross Price')"
            :value="currencyFormatter().format(price)"
          />
          <SfProperty
            class="column-property price m-tb-10"
            v-if="priceNetto && showPriceNetto()"
            :name="$t('Net Price')"
            :value="currencyFormatter().format(priceNetto)"
          />
          <SfProperty
            class="column-property m-tb-10"
            v-if="product.Total"
            :name="$t('Sub Total')"
            :value="currencyFormatter().format(product.Total)"
          />
          <SfProperty
            v-if="product.Product.Discount"
            class="m-tb-10"
            :name="$t('Discount')"
            :value="`${product.Product.Discount}%`"
          />
          <div v-for="property in properties" :key="property.name">
            <SfProperty
              :class="property.customClass"
              :name="property.name"
              :value="property.value"
            />
          </div>
          <div v-if="false">
            <SfProperty class="m-b-5" :name="$t('Stock')" />
            <div v-for="stock in product.Product.WarehouseInventory" :key="stock.WarehouseId">
              <SfProperty :name="warehouseName(stock.WarehouseId)" :value="stock.StockQuantity" />
            </div>
          </div>
        </template>
      </div>
      <div v-if="!isProductAvailable && !isPreview">
        <p class="text-danger error-info">{{ $t("Product temporarily unavailable.") }}</p>
      </div>
    </div>
    <div>
      <SfButton @click="removeItem" class="sf-button--text m-t-10">
        {{ $t("Remove item") }}
      </SfButton>
    </div>
  </div>
</template>

<script>
import {
  SfQuantitySelector, SfHeading, SfProperty, SfButton,
} from '@storefront-ui/vue/';

import logo from '@/assets/logo.png';
import { config } from '@/modules/core';
import cart from '../mixins/cart';

const availabilityPrice = 0;

export default {
  name: 'CollectedProduct',
  mixins: [cart, config],
  components: {
    SfQuantitySelector,
    SfHeading,
    SfProperty,
    SfButton,
  },
  data() {
    return {
      imageWidth: 140,
      imageHeight: 200,
      qty: this.product.Quantity,
      oldPrice: this.product.Product.OldPrice,
      oldPriceNetto: this.product.Product.OldPriceNetto,
      price: this.product.Product.Price,
      priceNetto: this.product.Product.PriceNetto,
      isHidden: false,
    };
  },
  props: {
    product: {
      reqired: true,
      type: Object,
    },
    isPreview: {
      type: Boolean,
    },
  },
  computed: {
    isProductAvailable() {
      return this.price && this.price > availabilityPrice;
    },
    picture() {
      const url = this.product.Product?.PictureUrl;
      return url ? this.pictureUrlPath(url) : logo;
    },
    properties() {
      return [];
    },
  },
  methods: {
    productQty(qty) {
      if (qty <= 0) return;
      this.qty = qty;
      this.updateCartItem({
        Quantity: qty,
        ProductId: this.product.Product.Id,
      });
    },
    removeItem() {
      this.deleteCartItem({ ProductId: this.product.Product.Id });
    },
    showPriceNetto() {
      return !!this.storeConfig?.general?.showPriceNetto;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@storefront-ui/shared/styles/_helpers";
@import "src/scss/_breakpoint.scss";

.product-item {
  padding: 20px 10px;
}

.product-item + .product-item {
  border-top: 1px solid var(--c-light);
}

.active,
.product-item:hover {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}

.sku-prop {
  --property-name-font-size: 16px;
  --property-value-font-size: 16px;
}

.column-property {
  flex-direction: column;
  --property-value-font-size: 20px;
}

.old-price {
  --property-value-color: var(--c-danger);
  /deep/ .sf-property__value {
    text-decoration: line-through;
  }
}

.price,
.discount {
  --property-value-color: var(--c-primary);
}
</style>
